module.exports = __webpack_public_path__ + "img/404-logo-icrea.9114d068.svg";